import SitemapPagination from './SitemapPagination';

export default SitemapPagination;
